export default __webpack_public_path__ + "static/media/Snd_LittleLineMiddle.0c431a3e.mp3";